import {Component, HostListener, Input, OnInit, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {ClientApiService} from '../client-api.service';
import {PdfModalComponent} from '../pdf-modal/pdf-modal.component';

@Component({
  selector: 'invoice-summary',
  templateUrl: './invoice-summary.component.html',
  styleUrls: ['./invoice-summary.component.scss']
})
export class InvoiceSummaryComponent implements OnInit {

  @Input() invoice: Invoice;
  @Input() view: string;

  @ViewChild('pdfModal') pdfModal: PdfModalComponent;

  pdf$: Observable<Blob>;

  constructor(private Api: ClientApiService) {
  }

  ngOnInit() {
    // Only subscribed to when PDF modal opens
    this.pdf$ = this.Api.getInvoicePdf(this.invoice.invoiceId);
  }

  @HostListener('click', ['$event'])
  openInvoicePdf(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.pdfModal.show();
  }
}
